import moment from "moment";
import { jwtDecode } from 'jwt-decode';

//Установка правильных окончаний слов
export const getWordEnding = (n, text_forms) => {
  n = Math.abs(n) % 100; var n1 = n % 10;
  if (n > 10 && n < 20) { return text_forms[2]; }
  if (n1 > 1 && n1 < 5) { return text_forms[1]; }
  if (n1 === 1) { return text_forms[0]; }
  return text_forms[2];
};

//Внешний вид номера телефона (10 цифр)
export const formatPhone = phone => {
  var tt = phone.split('');
  tt.splice(1,"", " ");
  tt.splice(5,"", " ");
  tt.splice(9,"", "-");
  tt.splice(12,"", "-");

  //Первая цифра
  let newPhone = tt.join('');
  if ((parseInt(tt[0], 10)) === 7) newPhone = `+${newPhone}`;
  return newPhone;
};

//Пример
getWordEnding(22, ['уведомление', 'уведомления', 'уведомдений']);

export const getTokensFromLocalStorage = () => {
  const tokens = {
    accessToken: localStorage.getItem("accessToken"),
    refreshToken: localStorage.getItem("refreshToken"),
  }
  return tokens;
}

//Сохранение токенов в Localstorage
export const setTokensInLocalStorage = (accessToken, refreshToken) => {
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  return true;
};

//Сохранить номер телефона и временный токен из первого шага авторизации
export const setPhoneAndTokenInLocalStorage = (tempToken, phoneNumber) => {
  localStorage.setItem("tempToken", tempToken);
  localStorage.setItem("phoneNumber", phoneNumber);
  return true;
};

//Проверка валидности токена
export const checkToken = (token) => {
  const now = new Date();
  //Время жизни токена сохранено в самом токене
  const tokenData = jwtDecode(token);
  const tokenValidUntil = tokenData && tokenData.valid_through;
  //Проверяем время жизни токена
  const tokenIsValid = moment(tokenValidUntil).isAfter(now);
  if (tokenIsValid) return true;
  return false;
};

export const setListsPayload = (limit, activePage, activeSearch, sorting) => {
  //Пагинация:
  //limit - количество пользователей на одну страницу пагинации
  //page - активная страница
  const payload = {
    limit,
    page: activePage,
    sort: sorting.sort,
    order: Number(sorting.order),
  };
  if (activeSearch.length !== 0) payload.search = activeSearch;
  return payload;
};

export const mapContentTypes = (contentType, i) => {
  const newContentType = {};
  newContentType.value = contentType;
  switch (contentType) {
    case 'news':
      newContentType.label = "Новость";
      break;
    case 'article':
      newContentType.label = "Статья";
      break;
    case 'poll':
      newContentType.label = "Опрос";
      break;
    case 'recipes':
      newContentType.label = "Рецепт";
      break;
    case 'videos':
      newContentType.label = "Видео";
      break;
    case 'instagram':
      newContentType.label = "Публикация в Instagram";
      break;
    default:
      newContentType.label = contentType;
      break;
  }
  //Добавим свойство checked для управления чекбоксом
  //По умолчанию выбраны все чекбоксы
  newContentType.checked = true;
  return newContentType;
}

export const getMsgTypeText = type => {
  switch (type) {
    case 'release':
      return 'Release notes';
    case 'info':
      return 'Info';
    default:
      return 'Release notes';
  }
}

